import * as React from "react";
import { Props } from "../../types/global";
import NumberComp from "./Number";
import Summary from "./Summary";
import Order from "./Order";
import Operator from "./Operator";
import Payment from "./Payment";
import { Session, Country, Product, Sku, CreditCardPayment, CreditCard, StoredCreditCard, SiteSettings, PaymentCountry, RecipientInformation } from "../types";
import { ProductCategory, SkuCategory } from "../types-enums";
// import ExchangeRate from "./ExchangeRate";
import Basket from "./Basket";
import Workflow from "./Workflow";
import { TopupService } from "../services/topup-service";
import { ICreditCard } from "../common/credit-card-factory";
import { FingerprintFactory, IFingerprint } from "../common/finger-print-factory";
import TopupManager from "./topup-manager";
import GiftCardManager from "../giftcard/giftcard-manager";
import { Loading } from "../common/Loading";
import { Step, StepName } from "./step";
import { CatalogService } from "../services/catalog-service";
import { isMobileNumberValid, isDev, uuidv4 } from "../utils";
import { messageDialog } from "../dialogs/MessageDialog";
import { GTMDataLayer } from "../services/gtm-datalayer";
import t from "../i18n";
import { dialogService } from "react-api-dialog";
import { removeGuestEmail } from "../services/helper-service";
import Cookies from "js-cookie";
import RecipientInfoComponent from "src/giftcard/RecipientInfoComponent";

// declare type ReceiptResponse = {responseCode: number, responseMessage: string, payLoad: ReceiptTrx | undefined};
export declare type TopupProps = Props<undefined, {
    step: string | undefined,
    sid: string, token: string, cc: string | undefined,
    m: string | undefined, p: string | undefined,
    cat: string | undefined,
}>;
export declare type TopupState = {
    step: Step;
    session: Session;
    countries: Country[];
    selectedCountry?: Country;
    products: Product[];
    selectedProduct?: Product;
    selectedSkuCategory: SkuCategory | undefined;
    payment: { paymentMethod: "cc" | "pp" | "zz", creditCardPayment: CreditCardPayment };
    siteSettings: SiteSettings;
    storedCreditCards: StoredCreditCard[];
    addressSettings: any;
    fingerPrintHelpers: IFingerprint[];
    creditCardHelper?: ICreditCard;
    paymentCountries: PaymentCountry[];    
    recipientInfo: RecipientInformation;
    allCountries: Country[];
    storePinCode:string;
    storePinBalance:string;
}
const creditCardDev: CreditCard = isDev ? {
    // creditCardNumber: "4111111111111111",
    // expiryMonthyear: "12/23",
    // cvvCode: "123",
    // lastName: "Jane Doe",
    // streetAddress: "123 Freedom dr.",
    // state: "IL",
    // city: "Oswigo",
    // zipCode: "12345",
    // storeCc: true,
} as CreditCard : { storeCc: true } as CreditCard
export default class Topup extends React.Component<TopupProps, TopupState> {
    _paymentComp: Payment | null;
    _summaryComp: Summary | null;
    _recipientComp: RecipientInfoComponent | null;
    readonly topupManager: TopupManager = new TopupManager(this);
    readonly giftCardManager: GiftCardManager = new GiftCardManager(this);
    constructor(props: TopupProps) {
        super(props);
        // let step = parseInt(this.props.location.query.step, undefined);
        // step = isNaN(step) || step > 5 ? 1 : step;
        const paymentMethod = props.location.query.token ? "pp" : "cc";
        const stepName = new Step(true).parse(props.location.query.step) || "number";
        this.state = {
            step: new Step(true).set(stepName),
            session: { sessionId: props.location.query.sid } as Session,
            payment: { paymentMethod: paymentMethod, creditCardPayment: { creditCardMethod: "new", creditCard: creditCardDev } },
            countries: [], products: [],
            siteSettings: {} as SiteSettings,
            storedCreditCards: [],
            addressSettings: {},
            paymentCountries: [],
            fingerPrintHelpers: [],
            selectedSkuCategory: undefined,
            recipientInfo: {} as RecipientInformation,
            allCountries:[],
            storePinCode:"",
            storePinBalance:""
        };
    }
    numberComp: NumberComp | null;
    assignMobileNumRef = (ref: NumberComp | null) => {
        this.numberComp = ref;
    }
    async componentDidMount() {
        if (this.state.step.current === "number") {
            // only reset guest email if the customer is restarting, not on payment or summary
            removeGuestEmail();
        }
        if (!this.state.session.sessionId) return;
        const { cc: queryCountryCode, m: queryMobileNumber, p: queryProductId, cat: queryCategory } = this.props.location.query;
        //const response = await TopupService.fetchSession(this.state.session.sessionId, queryCountryCode);
        const response = await TopupService.fetchSessionByCategory(this.state.session.sessionId, ProductCategory.GiftCard, queryCountryCode);
        //debugger;
        if (!response || response.responseCode !== 0) {
            if (response && response.responseCode === -10) {
                this.props.location.replace({ sid: uuidv4() });
                return;
            }
            else {
                messageDialog(t.error("general_error"), t.menu("send_balance"));
            }
        }
        const { session, countries, siteSettings, allCountries } = response.payLoad;
        const mc_cid = document.getElementById("mc_cid") as HTMLInputElement | undefined;
        const mc_eid = document.getElementById("mc_eid") as HTMLInputElement | undefined;
        const aicid = document.getElementById("aicid") as HTMLInputElement | undefined;
        session.campaignId = mc_cid ? mc_cid.value : undefined;
        session.campaignMemberId = mc_eid ? mc_eid.value : undefined;
        session.aicId = aicid ? aicid.value : undefined;
        let { products } = response.payLoad;
        //debugger;
        const deviceFingerPrintSettings = await TopupService.getFingerprintTags(this.state.session.sessionId, session.sourceCurrencyCode);
        const fingerPrintHelpers = FingerprintFactory.getHelpers(deviceFingerPrintSettings.payLoad);
        //const fobj = fingerPrintHelpers[0];
        //riskifiedSessionId = fobj?._params["webSessionId"];
        this.setState({ fingerPrintHelpers: fingerPrintHelpers });
        let selectedProduct = products ? products.find(p => p.productId === ((queryProductId ? parseInt(queryProductId, 10) : undefined) || session.productId)) : undefined;
        let selectedCountry: Country | undefined;
        let selectedSkuCategory: SkuCategory | undefined;
        if (queryCategory) {
            selectedSkuCategory = +queryCategory;
        }
        if (selectedProduct) {
            selectedCountry = countries.find(c => c.countryCode === selectedProduct!.countryCode);
        } else {
            if (queryCountryCode) {
                selectedCountry = countries.find(c => c.countryCode === queryCountryCode);
            } else {
                selectedCountry = countries.find(c => c.countryCode === session.countryCode);
            }
        }
        if (selectedCountry) {
            session.countryCode = selectedCountry.countryCode;
            session.internationalCode = selectedCountry.internationalCode;
            if (queryMobileNumber) {
                session.mobileNumber = queryMobileNumber;
                session.isValidMobileNumber = isMobileNumberValid(selectedCountry, selectedProduct, queryMobileNumber);
            }
            if (products) {
                //const productsObj = await CatalogService.getProducts(selectedCountry.countryCode, session.sourceCurrencyCode);
                const productsObj = await CatalogService.getGiftCardProducts(selectedCountry.countryCode, session.sourceCurrencyCode);
                debugger;
                products = productsObj.products;
            }
            if (queryProductId) {
                selectedProduct = products ? products.find(p => p.productId === parseInt(queryProductId, 10)) : undefined;
            }
            if (selectedProduct) {
                session.productId = selectedProduct.productId;
            }
        }
        const settings = this.state.step.current === "payment" ?
            await this.topupManager.loadCreditCardDetails(session.sourceCurrencyCode) : undefined;
        const storedCreditCards = settings ? settings.storedCreditCards : [];
        //TODO: If storedCreditCard are present, assign it topayment
        const oldStep = this.state.step;
        let newStep = new Step(!siteSettings.isSingleOperator);
        newStep = session.isValidMobileNumber ?
            (selectedProduct ? newStep.set("order") : newStep.set("operator")) :
            newStep.set("number");
        if (oldStep.compareTo(newStep) === ">") newStep = oldStep;
        //if the session does not exists in db, set the step to number
        if (!session.mobileNumber) newStep = newStep.set("number");
        this.setState({
            storedCreditCards: storedCreditCards,
            paymentCountries: settings ? settings.paymentCountries : [],
            addressSettings: settings ? settings.addressSettings : undefined,
            creditCardHelper: settings ? settings.creditCardHelper : undefined,
            fingerPrintHelpers: fingerPrintHelpers,
            session: session,
            countries, products,
            siteSettings, selectedCountry,
            selectedProduct,
            selectedSkuCategory,
            step: newStep,
            payment: {
                ...this.state.payment,
                paymentMethod: (response.payLoad.session.netCharge === 0 && oldStep.current === "payment") ?
                    "zz" : this.state.payment.paymentMethod,
                creditCardPayment: {
                    ...this.state.payment.creditCardPayment,
                    creditCardMethod: storedCreditCards.length === 0 ? "new" : "stored",
                    creditCard: { ...this.state.payment.creditCardPayment.creditCard!, country: session.locationCountry || "US" },
                    storedCard: storedCreditCards.length > 0 ? storedCreditCards[0] : undefined
                }
            },
            allCountries
        });
        this.props.location.replace({ ...this.props.location.query, step: newStep.current });

        this.populateRiskifiedBeacon();  
    }

    async componentWillUnmount() {
        for (let i = 0; i < this.state.fingerPrintHelpers.length; i++) {
            this.state.fingerPrintHelpers[i].detachScript();
        }
    }

    componentWillReceiveProps(nextProps: TopupProps) {
        let oldStepName: StepName = (this.props.location.query.step || "number") as StepName;
        let newStepName: StepName = (nextProps.location.query.step || "number") as StepName;
        oldStepName = oldStepName.toLowerCase() as StepName;
        newStepName = newStepName.toLowerCase() as StepName;
        if (oldStepName === newStepName) {
            return;
        }
        const currentStep = this.state.step;
        if (newStepName === currentStep.current) return;
        if (currentStep.compareTo(newStepName) === ">") {
            this.setState({ step: this.state.step.set(newStepName) });
        }
    }
    onCountrySelected = async (country: Country) => {
        const step = await this.giftCardManager.onCountryOrMobileNumberChanged(country, this.state.session.mobileNumber);
        this.props.location.replace({ ...this.props.location.query, step: step.current });
    }
    onMobileNumberChanged = async (mobileNumber: string) => {
        const step = await this.giftCardManager.onCountryOrMobileNumberChanged(this.state.selectedCountry!, mobileNumber);
        this.props.location.replace({ ...this.props.location.query, step: step.current });
    }
    onProductChanged = (product: Product) => {
        this.giftCardManager.onProductChanged(product);
        this.props.location.replace({ ...this.props.location.query, step: "order" });
    }
    onStepChanged = (stepName: StepName) => {
        this.populateRiskifiedBeacon();
        if (stepName === "number" || stepName === "operator") {
            if (this.state.siteSettings.isSingleOperator) {
                this.setState({ step: this.state.step.set("order"), session: { ...this.state.session } });
                this.props.location.replace({ ...this.props.location.query, step: "order" });
            } else {
                this.setState({ step: this.state.step.set("operator"), selectedProduct: undefined, session: { ...this.state.session, productId: undefined, skuId: undefined } });
                this.props.location.replace({ ...this.props.location.query, step: this.state.step.current });
            }
        } else if (stepName === "order") {
            this.setState({ step: this.state.step.set("order") });
            this.props.location.replace({ ...this.props.location.query, step: stepName });
        } else if (stepName === "recipient") {
            this.setState({ step: this.state.step.set("recipient") });
            this.props.location.replace({ ...this.props.location.query, step: stepName });
        } else if (stepName === "summary") {
            this.setState({ step: this.state.step.set("summary") });
            this.props.location.replace({ ...this.props.location.query, step: stepName });
        }
    }

    populateRiskifiedBeacon=async()=>{
        //sends webSessionId to riskified beacon
        const riskifiedBeaconId=Cookies.get('riskifiedBeaconId');
        const store_domain = "etopuponline.com";
        const beaconURL =
            ("https:" == document.location.protocol ? "https://" : "http://") +
            "beacon.riskified.com?shop=" + store_domain + "&sid=" + riskifiedBeaconId;            
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = beaconURL;
        document.head.appendChild(script);
    }    
    getStorePinBalance=async (storePinCode:string) => {
		//const storePinBalance=this.topupManager.getStorePinBalance(storePinCode);
	}

    onNext = async () => {        
        this.populateRiskifiedBeacon();
        if (this.state.step.current === "order") {
            this.props.location.replace({ ...this.props.location.query, step: "recipient" });
            this.setState({ step: this.state.step.set("recipient") });
        } else if (this.state.step.current === "recipient") {
            if (!this._recipientComp) return;
            const isRecipientValid = this._recipientComp.validate();
            if (!isRecipientValid) {
                messageDialog(t.validations("enter_valid_recipient_info"), t.menu("buy_gift_card"))
                return;
            }
            const isSuccessful = await this.topupManager.navigateToSummary();
            if (isSuccessful === "MOBILE_INVALID") {
                if (this.numberComp) this.numberComp.focus();
            } else if (isSuccessful === "SUMMARY") {
                this.props.location.replace({ ...this.props.location.query, step: "summary" });
            } else if (isSuccessful === "NEW_TOPUP") {
                const session = this.state.session;
                this.props.location.replace({ sid: uuidv4(), step: "order", m: session.mobileNumber, p: session.productId });
            }
        } else if (this.state.step.current === "summary") {
            if (!this._summaryComp) return;
            const validationError = this._summaryComp.validate();
            if (validationError) {
                messageDialog(validationError, t.menu("send_balance"))
                return;
            }
            const isSuccessful = await this.topupManager.navigateToPayment();
            if (isSuccessful) {
                this.props.location.replace({ ...this.props.location.query, step: "payment" });
            }
        } else if (this.state.step.current === "payment") {
            if (!this._paymentComp) return;
            const validationError = this._paymentComp.validate();
            if (validationError) {
                messageDialog(validationError, t.menu("send_balance"))
                return;
            }
            let url: string | undefined;
            try {
                if (this.state.payment.paymentMethod === "cc") {
                    GTMDataLayer.addPaymentInfo(this.state.session, this.state.payment.paymentMethod);
                    url = await this.topupManager.processCreditCard();
                } else if (this.state.payment.paymentMethod === "pp") {
                    GTMDataLayer.addPaymentInfo(this.state.session, this.state.payment.paymentMethod);
                    url = await this.topupManager.processPaypal();
                } else if (this.state.payment.paymentMethod === "zz") {
                    url = await this.topupManager.processZeroPayment();
                }
            } catch (e) {
                await dialogService.hidePreloader();
                if (e.code === "ECONNABORTED") {
                    this.props.history.push(`/timeout?sessionId=${this.state.session.sessionId}`);
                } else {
                    messageDialog(t.error("error_contact_support"), t.menu("send_balance"));
                }
                return;
            }
            if (url) this.props.history.push(url);
        }
    }
    renderHeader() {
        if (this.state.step.current === "summary") {
            return <div className="form-group form-title">
                <h1>{t.menu("order_summary")}</h1>
            </div>
        } else if (this.state.step.current === "payment") {
            return <div className="form-group form-title">
                <h1>{t.menu("payment")}</h1>
                <h6>{t.topup("payment_sub_heading")}</h6>
            </div>
        } else {
            return <div className="form-group form-title">
                {/* <h1>{t.topup("topup_heading")}</h1>
                <h6>{t.topup("topup_sub_heading")}</h6> */}
                <h1>{t.menu("buy_gift_card")}</h1>
            </div>
        }
    }
    renderComponent(sku: Sku | undefined) {
        const session = this.state.session;
        const numberComponent = <div className="form-group">
            {/* <h5 id="mobile-number-label">{t.topup("mobile_number_placeholder")}</h5> */}
            <h5>{t.topup("recipient_mobile")}</h5>
            <NumberComp ref={this.assignMobileNumRef} country={this.state.selectedCountry}
                product={this.state.selectedProduct}
                mobileNumber={session.mobileNumber}
                onMobileNumberChanged={this.onMobileNumberChanged}
                countries={this.state.countries}
                onCountrySelected={this.onCountrySelected}
                focusOnMe={true}
            />
        </div>;
        const isSingleProduct = this.state.siteSettings.isSingleOperator;
        const operatorComponent = isSingleProduct ? null : <div className="form-group">
            <h5>{t.topup("select_operator_gift")}</h5>
            <Operator products={this.state.products}
                selectedProductId={this.state.selectedProduct ? this.state.selectedProduct.productId : undefined}
                onProductChanged={this.onProductChanged}
            />
        </div>;
        // afghanistan message // lebanon message
        const orderComponent = <React.Fragment>
            {/* <ExchangeRate selectedProduct={this.state.selectedProduct}
                sourceCurrencyCode={this.state.session.sourceCurrencyCode} sourceCountryFlag={this.state.session.sourceCountryFlagUrl} /> */}
            <div className="form-group">
                <h5>{t.topup("select_amt_label_gift")}</h5>
                <Order product={this.state.selectedProduct!}
                    sourceCurrencyCode={this.state.session.sourceCurrencyCode}
                    selectedSkuId={this.state.session.skuId}
                    selectedSkuCategory={this.state.selectedSkuCategory}
                    onSkuSelected={this.topupManager.onSkuChanged}
                    showTopupTabFirst={this.state.siteSettings.showTopupTabFirst}
                />
            </div>
        </React.Fragment>
        if (this.state.step.current === "operator") {
            return <React.Fragment>
                {numberComponent}
                {operatorComponent}
            </React.Fragment>
        } else if (this.state.step.current === "order") {
            return <React.Fragment>
                {numberComponent}
                {operatorComponent}
                {orderComponent}
            </React.Fragment>
        }  else if (this.state.step.current === "recipient") {
            return <RecipientInfoComponent ref={r => this._recipientComp = r}
                session={this.state.session}
                siteSetting={this.state.siteSettings} recipientInfo={this.state.recipientInfo}
                recipientChanged={this.giftCardManager.recipientInfoChanged} country={this.state.selectedCountry}
                product={this.state.selectedProduct} countries={this.state.countries} 
                allCountries={this.state.allCountries}
            />
        } else if (this.state.step.current === "summary") {
            return <Summary ref={s => this._summaryComp = s} session={this.state.session}
                sku={sku} siteSettings={this.state.siteSettings}
                converSalesTaxChanged={this.topupManager.onCoverSalesTaxChanged}
                smsChanged={this.topupManager.onSmsChanged}
                applyCouponCode={this.topupManager.applyCouponCode}
                applyRewardPoints={this.topupManager.applyRewardPoints}
            />
        } else if (this.state.step.current === "payment") {
            return <Payment ref={p => this._paymentComp = p}
                payment={this.state.payment}
                paymentMethodChanged={this.topupManager.paymentMethodChanged}
                creditCardMethodChanged={this.topupManager.creditCardMethodChanged}
                creditCardChanged={this.topupManager.creditCardChanged}
                storedCreditCardChanged={this.topupManager.storedCreditCardChanged}
                countries={this.state.paymentCountries}
                addressSettings={{ usUkCa: true, others: true }}
                storedCreditCards={this.state.storedCreditCards}
                storeCard={this.state.session.guestEmail ? false : true}
                productId={this.state.selectedProduct ? this.state.selectedProduct.productId : 0}
                siteSetting={this.state.siteSettings}
                session={this.state.session}
                showNotificationSubscription={this.state.session.guestEmail ? false : true}
            />
        } else {
            return <React.Fragment>
                {numberComponent}
                {/* {(this.state.products && this.state.products.length > 0) ? operatorComponent : null} */}
            </React.Fragment>
        }
    }
    getSku = () => {
        if (!this.state.session.skuId) return undefined;
        const product = this.state.selectedProduct;
        if (!product) return undefined;
        const selectedSku = product.skus.concat(product.dataSkus).find(s => s.skuId === this.state.session.skuId);
        return selectedSku;
    }
    render() {
        if (this.state.countries.length === 0) return <Loading />;
        const sku = this.getSku();
        return <div className="container-fluid small-gutter" style={pageWidth}>
            <Workflow step={this.state.step} onStepChanged={this.onStepChanged} />
            {this.renderHeader()}
            {this.renderComponent(sku)}
            <Basket session={this.state.session}
                selectedProduct={this.state.selectedProduct}
                selectedSku={sku}
                onNext={this.onNext}
                step={this.state.step}
            />
        </div>
    }
}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
    minHeight: 500,
}

